import { cn } from '@commenda/utils';
import { useBillingContext } from '../context/billingContext';
import { BillingItemCard } from './BillingItemCard';

export const BillingItemList = ({ className }: { className?: string }) => {
  const { billingItems } = useBillingContext();
  return (
    <div className="flex flex-col gap-6 grow">
      <div className={cn('flex flex-col gap-6', className)}>
        {billingItems.map((billingItem) => (
          <BillingItemCard billingItem={billingItem} key={billingItem.id} />
        ))}
      </div>
    </div>
  );
};
